import { Injectable } from '@angular/core';

import { buildFilePreviewHtml } from './file-preview-html';

@Injectable({ providedIn: 'root' })
export class NativeFileHandlerService {
  public render(
    previewWindow: Window,
    objectUrl: string,
    fileName: string,
    fileMimeType: string | null,
    useMobileImagePreview: boolean
  ): void {
    previewWindow.document.open();
    previewWindow.document.write(
      buildFilePreviewHtml({
        objectUrl,
        fileName,
        fileMimeType,
        useMobileImagePreview,
        returnUrl: window.location.href,
      })
    );
    previewWindow.document.close();
    previewWindow.document.title = fileName;

    const downloadLink = previewWindow.document.getElementById('preview-download-link') as HTMLAnchorElement | null;

    if (downloadLink) {
      downloadLink.download = fileName;
    }
  }
}
